import React from 'react';
import { VideoPlayer } from 'lib/components/VideoPlayer';

export function VideoBlock({ blockProps }) {
	const { entityData, videoWidth, videoHeight } = blockProps;
	return (
		<VideoPlayer {...entityData} width={videoWidth} height={videoHeight}></VideoPlayer>
	)
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/videoPlugin/VideoBlock.jsx